import React from 'react';

const IconButton = ({ text, type = 'submit', onClick, children, customClasses }) => {
    return (
        <button
            onClick={onClick}
            type={type}
            className={customClasses}
        >
            {children ? (
                <div className='flex gap-x-2 justify-center items-center'>
                    {children}
                    <span>
                        {text}
                    </span>
                </div>
            ) : (<span>{text}</span>)
            }
        </button>
    );
}

export default IconButton;